<template>
  <div>
    <uploader
      :options="options"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      @file-error="onFileError"
      @complete="onComplete"
      :fileStatusText="filsStatusText"
      ref="uploader"
    >
      <uploader-drop v-if="drag" class="el-upload-dragger relative">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <uploader-btn class="w-full h-full !absolute opacity-0 top-0 left-0"></uploader-btn>
      </uploader-drop>
      <div v-if="tipShow" class="tip">
        {{ tip }}
      </div>
      <ul>
        <li
          class="w-490px p-0px px-4px mt-10px mb-5px hover:bg-$detailContentBg leading-28px flex justify-between items-center"
          v-for="item in copyFileList"
          :key="item.id"
        >
          <div class="flex-1 truncate cursor-pointer" @click="onPreview(item)">
            <i class="iconfont icon-bg-file"></i> {{ item.fileName || item.name }}
          </div>

          <span class="ml-5px cursor-pointer" v-if="!disabled" @click="beforeRemove(item)">
            <i
              class="float-right icon-line-close iconfont text-12px hover:text-$buttonDeleteBg hover:shadow"
            ></i>
          </span>
        </li>
      </ul>
    </uploader>
  </div>
</template>

<script>
import Vue from 'vue'
import SparkMD5 from 'spark-md5'
import { FileApi } from '@wiz-api/file-management'
import uploader from 'vue-simple-uploader'
import { round, split, find, filter, map } from 'lodash'
import { MaterialMediaApi } from '@wiz-api/material-management'

Vue.use(uploader)
const fileApi = new FileApi()
const materialMediaApi = new MaterialMediaApi()
/* eslint-disable */

export default {
  name: 'uploadFile',
  model: {
    prop: 'fileIds',
    event: 'change',
  },
  props: {
    // 查看
    disabled: {
      type: Boolean,
      default: false,
    },
    drag: {
      type: Boolean,
      default: true,
    },
    // 文本提示是否显示
    tipShow: {
      type: Boolean,
      default: true,
    },
    uploadText: {
      type: String,
      default: '上传文件',
    },
    FolderId: {
      type: String,
      default: '',
    },
    fileMaxsize: {
      type: Number || null,
      default: null, // 单位 M
    },
    fileAccept: {
      type: String,
      default: '',
    },
    // 绑定数值
    fileIds: {
      type: String,
      default: '',
    },
    // 单个文件上传
    singleFile: {
      type: Boolean,
      default: false,
    },
    // 文件上传数量
    maxFileCount: {
      type: Number || null,
      default: null,
    },
    // 文件列表附加信息 删除用
    fileMedias: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 分片大小
    chunkSize: {
      type: Number,
      default: 2, // 单位 M
    }
  },
  data() {
    const _this = this
    return {
      // fileList上传的时候会改变值，自己写个copyFileList
      fileList: [],
      copyFileList: [],
      fileInfo: null, // 合并后的文件信息
      // 用于替换组件原来的状态显示文字
      filsStatusText: {
        success: '成功',
        error: '失败',
        uploading: '上传中',
        paused: '暂停',
        waiting: '等待中',
      },
      // uploader 的主要配置
      options: {
        singleFile: this.singleFile, // 是否单文件上传
        chunkSize: this.chunkSize * 1024 * 1024, // 允许片段最大为2M，因为最后一块默认是可以大于等于这个值，但必须小于它的两倍。
        simultaneousUploads: 1, // 最大并发上传数
        uploadMethod: 'POST',
        testMethod: 'POST',
        forceChunkSize: true, // 是否强制所有的块都是小于等于chunkSize的值，默认为false
        headers: {
          Authorization: '',
        },
        testChunks: false,
        target: (val) => {
          return `${this.fileManagement}/api/file-management/files/chunk-upload/${val.uniqueIdentifer}/${val.chunkIndex}`
        }, // 目标上传 URL，若测试和上传接口不是同个路径，可以用函数模式
        permanentErrors: [404, 415, 500, 501, 413, 409, 403], //需进入错误回调函数中提示错误信息
        // 每次发起测试校验，所有分片都会进入这个回调
        checkChunkUploadedByResponse: function(chunk, message) {
          // 每次校验，chunk（片段）会不一样，但message（只有一个测试请求）一样
          let objMessage = JSON.parse(message)
          // 后端认为这个文件上传过，则直接跳过
          if (objMessage.skipUpload) return true

          // 若文件检测出现异常，则提示并返回false
          if (objMessage.error) {
            _this.$message.error(objMessage.message)
            return false
          }
          // 一些校验信息，需要用到的，可以绑定在chunk上
          chunk.xxx = objMessage.xxx // 可写可不写，看自己情况

          // chunk的offset就是分块后，该块片段在文件所有模块的位置
          return (objMessage.uploadedList || []).indexOf(chunk.offset + 1) >= 0
        },
        // 处理所有请求的参数
        processParams: async (params, file, chunk) => {
          if (params.chunkNumber === 1) {
            file.chunkIndex = file.chunkInitIndex
          } else {
            file.chunkIndex++
          }
          // file.chunkIndex = params.chunkNumber
          return params
        },
        processResponse: (res, cb) => {
          if (res) {
            const parseRes = JSON.parse(res)
            const progress = round(((parseRes.chunk + 1) / this.maxChunks) * 100)
            this.$emit('on-progress', progress >= 100 ? 99 : progress)
          }
          cb(null, res)
        },
      },
      maxChunks: 0,
    }
  },
  created() {
    if (this.fileIds) {
      this.fnGetFileList(split(this.fileIds, ','))
    } else {
      this.copyFileList = []
    }
  },
  watch: {
    fileIds(fileIds) {
      if (fileIds) {
        this.fnGetFileList(split(this.fileIds, ','))
      } else {
        this.fileList = []
        this.copyFileList = []
      }
    },
  },
  computed: {
    fileManagement() {
      const endpoints = Wiz.globalSettings?.api?.endpoints
      const defaultApi = endpoints ? endpoints.default : ''
      const fileApiModuleName = Wiz.globalSettings?.api?.modules['file-management']
      const fileDomain = endpoints ? endpoints[fileApiModuleName] : ''
      return fileDomain ? fileDomain : defaultApi
    },
    tip() {
      if (this.fileMaxsize)
        return `只能上传${this.fileAccept}文件，且上传不超过${this.fileMaxsize}M`
    },
  },
  methods: {
    onPreview(file) {
      this.downLoadFile(file)
    },
    // 附件，下载
    async downLoadFile(file) {
      const [err, res] = await fileApi.download(file.id, { returnType: 'Blob' })
      if (!err) {
        this.exportFile(res, file.name)
      }
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        type: 'success',
        message: '下载成功!',
      })
    },
    beforeRemove(file) {
      return this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action) => {
          if (action === 'confirm') {
            const deleteFileItem = find(this.fileMedias, ['fileInfoId', file.id])
            // 删除新增未保存的文件 临时文件
            if (!deleteFileItem) {
              const [err, res] = await fileApi.callDelete(file.id)
              if (!err) {
                this.copyFileList = filter(this.copyFileList, (i) => {
                  return i.id !== file.id
                })
              }
            } else {
              // 删除已保存的动效模型文件
              const [err, res] = await materialMediaApi.callDelete(deleteFileItem.id)
              if (!err) {
                this.copyFileList = filter(this.copyFileList, (i) => {
                  return i.id !== file.id
                })
              }
            }
            this.fileList = this.copyFileList
            this.$emit(
              'change',
              map(this.copyFileList, (i) => {
                return i.id
              }).join(',')
            )
          }
        },
      })
    },
    // 获取附件列表
    async fnGetFileList(fileIds) {
      this.fileList = []
      this.copyFileList = []
      fileIds.forEach(async (id) => {
        const [err, res] = await fileApi.get(id)
        if (!err) {
          this.copyFileList.push(res)
          this.fileList.push(res)
        }
      })
    },
    fileRemove(index) {
      this.$refs.uploader.fileList.splice(index, 1)
      this.$refs.uploader.files.splice(index, 1)
    },
    onComplete() {},
    // 导入文件时
    onFileAdded(file) {
      if (this.maxFileCount && this.fileList?.length >= this.maxFileCount) {
        this.$message.warning(`文件个数超出限制`)
        file.pause()
        file.cancel()
        return false
      }
      if (this.fileAccept) {
        const fileFormat = this.fileAccept.split(',').includes(
          file.name
            .split('.')
            .at(-1)
            .toLowerCase()
        )
        // 附件不限制文件格式
        if (!fileFormat) {
          this.$message.warning(`请上传指定格式的文件，${this.fileAccept}`)
          file.pause()
          file.cancel()
          return false
        }
      }
      if (this.fileMaxsize) {
        const isGreatThenMaxsize = file.size / 1024 / 1024 > this.fileMaxsize
        if (isGreatThenMaxsize) {
          this.$message.error(`文件大小超过限制，最大为${this.fileMaxsize}M`)
          file.pause()
          file.cancel()
          return false
        }
      }
      // 计算文件 MD5 并标记文件
      this.computeMD5(file)
      return true
    },
    // 上传失败
    onFileError(rootFile, file, res) {
      this.$message.error(JSON.parse(res).error)
    },
    // 所有片段上传成功后，进入文件上传成功回调
    async onFileSuccess(rootFile, file, res) {
      // 后端返回成功的字段，插件认为只要所有片段的上传请求都成功了就是上传成功了，而对于其他的错误它是无法处理的
      // 如果后端返回可以合并的字段则发起合并请求
      if (res) {
        const axios = require('axios')
        let data = JSON.stringify({
          md5: file.uniqueIdentifer,
          fileName: file.name,
          folderId: '00000000-0000-0000-0000-000000000000',
          authLevel: 2,
        })

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${this.fileManagement}/api/file-management/files/merge-files`,
          headers: {
            'Content-Type': 'application/json',
            Cookie: '__tenant=11111111-1111-1111-1111-111111111111',
          },
          data: data,
        }

        axios
          .request(config)
          .then((res) => {
            console.log(res, '上传结果')
            this.fileInfo = res.data[0]
            this.$emit('filesUploadComplete', this.fileInfo)
          })
          .catch((err) => {
            this.$emit('on-error')
          })
      } else {
        // 分片上传成功，但整个文件上传并未结束，不需要合并
      }
    },
    // 根据文件内容计算 MD5 并标记文件 file
    computeMD5(file) {
      let fileReader = new FileReader()
      let time = new Date().getTime()
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      let currentChunk = 0
      const chunkSize = this.options.chunkSize
      let chunks = Math.ceil(file.size / chunkSize) // 总模块数
      let spark = new SparkMD5.ArrayBuffer()
      this.maxChunks = chunks

      file.pause() // 先暂停文件的上传过程

      loadNext() // 开始读取文件内容

      // FileReader 加载完成
      fileReader.onload = (e) => {
        console.log('开始读取')
        // 插入读取的片段内容到 SparkMD5 中
        spark.append(e.target.result)

        // 按分片顺序读取，小于最后模块位置的就继续读取
        if (currentChunk < chunks) {
          currentChunk++
          loadNext()
        } else {
          // 所有文件分片内容读取完成，生成MD5
          let md5 = spark.end()
          // 在computeMD5Success中标记文件
          this.computeMD5Success(md5, file)
        }
      }
      // FileReader 加载失败
      fileReader.onerror = function() {
        this.error(`文件${file.name}读取出错，请检查该文件`)
        file.cancel()
      }

      // 分片读取文件内容函数
      function loadNext() {
        console.log('加载fen')
        let start = currentChunk * chunkSize
        let end = start + chunkSize >= file.size ? file.size : start + chunkSize
        // fileReader 读取文件
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end))
      }
    },
    async computeMD5Success(md5, file) {
      console.log('开始长传')
      file.uniqueIdentifer = md5 // 标记文件file
      // 通过md5获取当前文件的切片号
      const [err, res] = await fileApi.getMaxChunk(file.uniqueIdentifer)
      if (!err) {
        if (res >= 0) {
          file.chunkInitIndex = res
        } else {
          file.chunkInitIndex = 0
        }
      }
      file.resume() // 继续上传
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .uploader-drop {
  background-color: var(--contentBgColor);
}
::v-deep .uploader-btn {
  background-color: var(--contentBgColor);
  border: 1px dashed var(--lineBorderColor);
  border-radius: 6px;
  &:hover {
    border-color: var(--uploadHoverColor);
  }
}
.tip {
  margin: 0;
  color: #939696;
  font-size: 12px;
}
</style>
